export const DISCOUNT_URL = 'p/loyalty/coupon/v1/';
export const DISCOUNT_TOKEN_URL = 'r/loyalty/coupon/v1/';
export const MY_DISCOUNT_TOKEN_URL = 'r/loyalty/coupon/v1/history/';
export const PAGE = 'page';
export const PAGE_SIZE = 'page_size';
